import React from 'react';
import { useNavigate } from 'react-router-dom';

import { useAppDispatch, useAppSelector } from '@hooks/statehooks';
import useToggleLiveChat from '@hooks/usetogglelivechat';

import { updateSelectedOptionsParams } from '@store/reducers/vehiclesearchparams';
import { setFinalisedState } from '@store/reducers/finalisedoptions';
import { useSelectedOptions } from '@hooks/useselectedoptions';
import { CONFIGURE_SEARCH } from '@navigation/constants';

import TotalCost from './totalcost';
import Typography from '@components/typography';

import '@styles/customise/option.scss';

const Footer: React.FC = () => {
  const { vehicleSearchParams, selectedOptions } = useAppSelector(
    (state) => state
  );
  const dispatch = useAppDispatch();
  const { showElement } = useToggleLiveChat();
  const { getNumberOfExtrasSelected, getTotalCostOfExtrasSelected } =
    useSelectedOptions();

  const fireDatalayerEvent = () => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'configureOptions',
      category: 'Save Options',
      action: 'click',
      lease: {
        no_of_extras: getNumberOfExtrasSelected(),
        cost_of_extras: getTotalCostOfExtrasSelected(),
      },
    });
  };

  let navigate = useNavigate();
  const handleFinish = () => {
    dispatch(updateSelectedOptionsParams());
    dispatch(
      setFinalisedState({
        colours: selectedOptions.colours,
        options: selectedOptions.options,
      })
    );

    navigate(CONFIGURE_SEARCH(vehicleSearchParams));
    fireDatalayerEvent();

    showElement();
  };

  return (
    <div className="customise-sidebar__footer">
      <TotalCost />
      <div className="customise-sidebar__footer-link">
        <button type="button" onClick={handleFinish}>
          <Typography
            variant="caption"
            size="2x"
            weight="semi-bold"
            colour="alternative"
          >
            Save options
          </Typography>
        </button>
      </div>
    </div>
  );
};

export default Footer;
